import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "App";
import "styles.css";
import { AuthContextProvider } from "store/auth-context";

// Material Dashboard 2 React Context Provider
import { MaterialUIControllerProvider } from "context";
import { RecoilRoot } from "recoil";

const container = document.getElementById("app");
const root = createRoot(container);

root.render(
  <BrowserRouter>
    <RecoilRoot>
      <MaterialUIControllerProvider>
        <AuthContextProvider>
          <App />
        </AuthContextProvider>
      </MaterialUIControllerProvider>
    </RecoilRoot>
  </BrowserRouter>
);
